import { render, staticRenderFns } from "./inquire_search.vue?vue&type=template&id=54f5b491&scoped=true"
import script from "./inquire_search.vue?vue&type=script&lang=js"
export * from "./inquire_search.vue?vue&type=script&lang=js"
import style0 from "./inquire_search.vue?vue&type=style&index=0&id=54f5b491&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5b491",
  null
  
)

export default component.exports